// @flow
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import styles from './checkPincode.scss';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import Pincode from '../../../models/pincode';
import Select from '../../commons/formElements/select/select';

import InputField from '../../commons/formElements/inputField/inputField';
import {
  checkPincodeServiceabilityNew,
  getFromToPairDetails,
  getAllServiceablePincodesViaClientCode,
  getClients
} from '../../../services/pincodeService/pincodeActionCreator';

import {
  SuccessCircleTickIcon,
  DocumentsListIcon,
  ClockIcon,
  BaseLineErrorIcon,
  BaseLineHelpIcon
} from '../../commons/icons/icons';
import {
  jsonToCSVConvertor,
  checkForExternalClient,
  rivigoUser,
  techSupportUser
} from '../../../services/helpers';

import WhatsappIcon from '../../../assets/images/whatsapp.svg';
import { PathsWithoutHeaders } from '../../../services/initService/Constants';
const information = require('../../../assets/images/information.svg');

type Props = {
  userProfile: Object,
  setPageName: Function,
  initServiceState: Object,
  checkPincodeServiceabilityNew: Function,
  getFromToPairDetails: Function,
  pincodeState: Object,
  switchClientDropdownState: Object,
  getAllServiceablePincodesViaClientCode: Function
};

type State = {
  fromPincode: Pincode,
  toPincode: Pincode,
  fromToPairDetails: Object,
  clientCode: String
};

const pageObj = {
  pageName: 'CHECK PINCODE'
};

// fields for our servicable pincode excel file
export const headers = [
  { label: 'Pincode', key: 'code' },
  { label: 'Pickup', key: 'pickupStatus' },
  { label: 'Delivery', key: 'deliveryStatus' },
  { label: 'Opa Charge BucketName', key: 'opaChargeBucketName' },
  { label: 'Opa Charge BucketValue', key: 'opaChargeBucketValue' },
  { label: 'Oda Charge BucketName', key: 'odaChargeBucketName' },
  { label: 'Oda Charge BucketValue', key: 'odaChargeBucketValue' },
  { label: 'Opa Extra Tat', key: 'opaExtraTat' },
  { label: 'Oda Extra Tat', key: 'odaExtraTat' }
];

const columnNameconvertor = (row: Object, columnName) =>
  !row[columnName] ? `${row[columnName]}` : row[columnName];
export const PincodeTableConfig = {
  columns: [
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[0].label,
      key: headers[0].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[1].label,
      key: headers[1].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[2].label,
      key: headers[2].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[3].label,
      key: headers[3].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      formatter: (row: Object) =>
        columnNameconvertor(row, 'opaChargeBucketValue'),
      Header: headers[4].label,
      key: headers[4].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[5].label,
      key: headers[5].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      formatter: (row: Object) =>
        columnNameconvertor(row, 'odaChargeBucketValue'),
      Header: headers[6].label,
      key: headers[6].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      formatter: (row: Object) => columnNameconvertor(row, 'opaExtraTat'),
      Header: headers[7].label,
      key: headers[7].key
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      formatter: (row: Object) => columnNameconvertor(row, 'odaExtraTat'),
      Header: headers[8].label,
      key: headers[8].key
    }
  ]
};

class CheckPincode extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.fromServiceableMessage = 'We pickup from this location';
    this.toServiceableMessage = 'We deliver to this location';
    this.fromNotServiceableMessage = "We don't pickup from this location yet";
    this.toNotServiceableMessage = "We don't deliver to this location yet";
    this.onlyFromDocsMessage =
      '*Additional documents might be required depending on the To location';
    this.onlyToDocsMessage =
      '*Additional documents might be required depending on the From location';
    this.odaMessage =
      'ODA - Out of Delivery Area- these locations take slightly more time than regular locations to be serviced';
    this.state = {
      fromPincode: new Pincode(''),
      toPincode: new Pincode(''),
      clientCode: '',
      fromToPairDetails: null,
      triggerDownload: false,
      selectedClient: null,
      isCalledFromRivigo: false,
      fontFamily: '',
      fontWeight: ''
    };
    this.serviceTypes = {
      ECOMMERCE: 'Ecommerce',
      'NON-ECOMMERCE': 'Non-Ecommerce',
      RETAIL: 'Retail'
    };
    this.selectedClientNameValString = {
      nameKey: 'clientCode',
      valKey: 'clientCode'
    };
  }

  componentWillMount() {
    this.props.setPageName(pageObj);

    if (PathsWithoutHeaders.includes(this.props.history.location.pathname)) {
      this.setState({ isCalledFromRivigo: true });
    }
  }

  componentDidMount() {
    if (rivigoUser(this.props.userProfile)) {
      this.props.getClients(this.props.userProfile);
    }
    if (this.state.isCalledFromRivigo) {
      this.loadGeoramaFontFromGoogleApi();
    }
  }

  loadGeoramaFontFromGoogleApi() {
    const link = document.createElement('link');

    link.href = `https://fonts.googleapis.com/css2?family=Georama:ital,wght@0,100..900;1,100..900&display=swap`;
    link.rel = 'stylesheet';

    document.head.appendChild(link);

    this.setState({
      fontFamily: 'Georama',
      fontWeight: 600
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.pincodeState.checkingInternal &&
      nextProps.pincodeState.pincodeDataInternal &&
      this.props.pincodeState.checkingInternal
    ) {
      const isFromPincode = nextProps.pincodeState.pincodeIndex === 0;
      const pincodeToUpdate = isFromPincode
        ? this.state.fromPincode
        : this.state.toPincode;
      const stateName = this.getStateName(isFromPincode);
      pincodeToUpdate.serviceable = true;
      pincodeToUpdate.dataInternal = nextProps.pincodeState.pincodeDataInternal;
      const odaDetail = this.getOdaDetails(
        nextProps.pincodeState.pincodeDataInternal
      );
      pincodeToUpdate.odaDetail = odaDetail;
      this.setState({
        [stateName]: pincodeToUpdate,
        triggerDownload: false
      });
    }
    if (
      !nextProps.pincodeState.checkingInternal &&
      !nextProps.pincodeState.pincodeDataInternal &&
      typeof nextProps.pincodeState.errorInternal === 'string' &&
      this.props.pincodeState.checkingInternal
    ) {
      const isFromPincode = nextProps.pincodeState.pincodeIndex === 0;
      const pincodeToUpdate = isFromPincode
        ? this.state.fromPincode
        : this.state.toPincode;
      const stateName = this.getStateName(isFromPincode);
      pincodeToUpdate.serviceable = false;
      this.setState({
        [stateName]: pincodeToUpdate,
        triggerDownload: false
      });
    }
    if (
      !nextProps.pincodeState.fetchingFromToPairDetails &&
      nextProps.pincodeState.fromToPairDetails &&
      this.props.pincodeState.fetchingFromToPairDetails
    ) {
      this.setState({
        fromToPairDetails: nextProps.pincodeState.fromToPairDetails,
        triggerDownload: false
      });
    }
    if (
      !nextProps.pincodeState.downloading &&
      nextProps.pincodeState.downloaded &&
      this.props.pincodeState.downloading
    ) {
      this.setState({
        triggerDownload: true
      });
    }
    if (
      nextProps.switchClientDropdownState.selectedClient &&
      nextProps.switchClientDropdownState.selectedClient !==
        this.props.switchClientDropdownState.selectedClient
    ) {
      this.setState(
        {
          clientCode:
            nextProps.switchClientDropdownState.selectedClient.clientCode
        },
        () => {
          const validateFn = this.props.initServiceState.pincodeproto
            .validatePincode;
          const pickupPincode = this.state.fromPincode;
          const deliveryPincode = this.state.toPincode;
          if (validateFn(pickupPincode) && validateFn(deliveryPincode)) {
            this.props
              .checkPincodeServiceabilityNew({
                pincode: pickupPincode.code,
                index: 0,
                type: 'PICKUP',
                isExternal: true,
                clientCode: this.state.clientCode
              })
              .then(() => {
                this.props.checkPincodeServiceabilityNew({
                  pincode: deliveryPincode.code,
                  index: 1,
                  type: 'DELIVERY',
                  isExternal: true,
                  clientCode: this.state.clientCode
                });
              });
          } else if (validateFn(pickupPincode)) {
            this.onPincodeChange(pickupPincode.code, null, true);
          } else if (validateFn(deliveryPincode)) {
            this.onPincodeChange(deliveryPincode.code, null, false);
          }
        }
      );
    }
  }

  onPincodeChange(val, target, isFromPincode, isInternal) {
    const stateName = this.getStateName(isFromPincode);
    const type = isFromPincode ? 'PICKUP' : 'DELIVERY';
    const validateFn = this.props.initServiceState.pincodeproto.validatePincode;
    const toSet = new Pincode(val);
    toSet.serviceable = null;
    toSet.dataInternal = null;
    this.setState(
      {
        [stateName]: toSet,
        fromToPairDetails: null,
        triggerDownload: false
      },
      () => {
        const pincodeConsidered = isFromPincode
          ? this.state.fromPincode
          : this.state.toPincode;
        const index = isFromPincode ? 0 : 1;
        const pincodeNotConsidered = isFromPincode
          ? this.state.toPincode
          : this.state.fromPincode;
        if (validateFn(pincodeConsidered)) {
          const isExternal =
            this.props.initServiceState.isExternalRoute ||
            checkForExternalClient(this.props.userProfile);
          this.props.checkPincodeServiceabilityNew({
            pincode: val,
            index,
            type,
            isExternal: isInternal ? false : isExternal,
            clientCode: this.state.clientCode
          });
          if (validateFn(pincodeNotConsidered)) {
            this.props.getFromToPairDetails({
              from: this.state.fromPincode.code,
              to: this.state.toPincode.code,
              isExternal: isInternal ? false : isExternal,
              clientCode: this.state.clientCode
            });
          }
        }
      }
    );
  }

  // function will trigger the download the servicable pincode based on client code
  onDownloadCsvViaClientCodeClick() {
    const isExternal =
      this.props.initServiceState.isExternalRoute ||
      checkForExternalClient(this.props.userProfile);

    this.props.getAllServiceablePincodesViaClientCode(
      this.state.clientCode,
      isExternal
    );
  }

  onExtraDaysInfoHoverOut() {
    setTimeout(() => {
      if (this.state.showOdaTooltip) {
        this.setState({
          showOdaTooltip: false
        });
      }
    }, 0);
  }

  onExtraDaysInfoHoverIn() {
    if (!this.state.showOdaTooltip) {
      this.setState({
        showOdaTooltip: true
      });
    }
  }

  getStateName(isFromPincode) {
    return isFromPincode ? 'fromPincode' : 'toPincode';
  }

  getNearestLocationName(ouDto) {
    if (!ouDto) {
      return '';
    }
    const pcString = `${
      ouDto.pcCode || ouDto.pcName ? ouDto.pcCode || ouDto.pcName : ''
    }`;
    return `${ouDto.locationName} ${pcString}`;
  }

  getOdaString(pincodeObject) {
    if (!pincodeObject) {
      return '';
    }
    const { odaDetail } = pincodeObject;
    const dayString = odaDetail === 1 ? 'day' : 'days';
    const serviceOptionString =
      pincodeObject.dataInternal &&
      pincodeObject.dataInternal.serviceOption === 'PICKUP'
        ? 'Extra OPA TAT'
        : 'Extra ODA TAT';
    const serviceChargeString =
      pincodeObject.dataInternal &&
      pincodeObject.dataInternal.serviceOption === 'PICKUP'
        ? 'Extra OPA Charge'
        : 'Extra ODA Charge';
    return (
      <div>
        <div>{`(${serviceOptionString}: ${odaDetail.additionalTat} ${dayString} )`}</div>
        <div>{`(${serviceChargeString}: ${odaDetail.additionalCharge} )`}</div>
      </div>
    );
  }

  getOdaDetails(pincodeDetails) {
    const odaDetail =
      pincodeDetails.serviceOption === 'PICKUP'
        ? pincodeDetails.pickupServiceability
        : pincodeDetails.deliveryServiceability;

    return odaDetail || null;
  }

  getTatDaysExtraMessage(tatDaysExtra) {
    if (typeof tatDaysExtra === 'number' && tatDaysExtra) {
      const dayString = tatDaysExtra === 1 ? 'day' : 'days';
      const message = `(Including ${tatDaysExtra} ${dayString} for OPA/ODA)`;
      return (
        <div className={`l-row pos-rel ${styles.mLeft}`}>
          {message || ''}
          <div
            className={styles.mLeft}
            onMouseLeave={() => this.onExtraDaysInfoHoverOut()}
            onMouseOver={() => this.onExtraDaysInfoHoverIn()}
            onFocus={() => this.onExtraDaysInfoHoverIn()}
            onBlur={() => this.onExtraDaysInfoHoverOut()}
          >
            <BaseLineHelpIcon />
          </div>
          {this.state.showOdaTooltip ? (
            <div className={styles.tooltip}>
              {this.odaMessage || 'Out of Delivery Area'}
            </div>
          ) : (
            ''
          )}
        </div>
      );
    }
    return '';
  }

  handleDownloadOnClick = () => {
    this.onDownloadCsvViaClientCodeClick();
  };

  handleSelect = (val, obj) => {
    if (obj && obj.clientCode && this.state.clientCode != obj.clientCode) {
      this.setState(
        {
          selectedClient: obj,
          clientCode: obj.clientCode
        },
        () => {
          const validateFn = this.props.initServiceState.pincodeproto
            .validatePincode;
          const pickupPincode = this.state.fromPincode;
          const deliveryPincode = this.state.toPincode;

          if (validateFn(pickupPincode) && validateFn(deliveryPincode)) {
            this.props
              .checkPincodeServiceabilityNew({
                pincode: pickupPincode.code,
                index: 0,
                type: 'PICKUP',
                isExternal: false,
                clientCode: obj.clientCode
              })
              .then(() => {
                this.props.checkPincodeServiceabilityNew({
                  pincode: deliveryPincode.code,
                  index: 1,
                  type: 'DELIVERY',
                  isExternal: false,
                  clientCode: obj.clientCode
                });
              });
          } else if (validateFn(pickupPincode)) {
            this.onPincodeChange(pickupPincode.code, null, true, true);
          } else if (validateFn(deliveryPincode)) {
            this.onPincodeChange(deliveryPincode.code, null, false, true);
          }
        }
      );
    }
  };

  renderKeyValPair(label, value) {
    if (!value) {
      return null;
    }
    return (
      <div className={styles.keyval}>
        <div className={`${styles.keyvalKey}`}>{label || ''}</div>
        <div className={`${styles.keyvalVal}`}>{value || ''}</div>
      </div>
    );
  }

  renderPincodeInfo(isFromPincode) {
    const label = isFromPincode ? 'From Pincode' : 'To Pincode';
    const pincodeBinded = isFromPincode
      ? this.state.fromPincode
      : this.state.toPincode;
    const isServiceableMsg = isFromPincode
      ? this.fromServiceableMessage
      : this.toServiceableMessage;
    const isNotServiceableMsg = isFromPincode
      ? this.fromNotServiceableMessage
      : this.toNotServiceableMessage;
    const { pincodeState } = this.props;
    let isDisabled = true;
    if (
      rivigoUser(this.props.userProfile) &&
      !techSupportUser(this.props.userProfile)
    ) {
      if (pincodeState && pincodeState.isLoaded) {
        if (
          pincodeState &&
          pincodeState.clientList &&
          pincodeState.clientList.length
        ) {
          isDisabled = !this.state.selectedClient;
        } else {
          isDisabled = false;
        }
      }
    } else {
      isDisabled = false;
    }

    return (
      <div className="flex-40 responsive-w-100">
        <div className="responsive-mt-20 responsive-ta-center">
          <InputField
            label={label}
            isCalledFromRivigo={this.state.isCalledFromRivigo}
            maxLength={this.props.initServiceState.pincodeproto.validLength}
            placeholder={label}
            onChange={(val, target) =>
              this.onPincodeChange(val, target, isFromPincode)
            }
            allowedInputKeys="onlynumber"
            inputClassName={`${styles.pincodeInput}
            ${pincodeBinded.serviceable === false ? 'input-failure' : ''}
            ${pincodeBinded.serviceable === true ? 'input-success' : ''}`}
            value={pincodeBinded.code}
            disabled={isDisabled}
          />
        </div>
        {pincodeBinded.serviceable === true ? (
          <div>
            <div
              className={`${styles.serviceableContainer} responsive-jc-center l-row a-center`}
            >
              <SuccessCircleTickIcon />
              <div className={`${styles.serviceableText} ${styles.success}`}>
                {`${isServiceableMsg || 'Serviceable'}`}
                {pincodeBinded.odaDetail
                  ? this.getOdaString(pincodeBinded)
                  : null}
              </div>
            </div>
            <div
              className={`${styles.serviceableContainer} responsive-ta-center`}
            >
              {this.renderKeyValPair(
                'Nearest Rivigo Location:',
                isFromPincode
                  ? pincodeBinded.dataInternal.nearestOUPickup &&
                      this.getNearestLocationName(
                        pincodeBinded.dataInternal.nearestOUPickup
                      )
                  : pincodeBinded.dataInternal.nearestOUDelivery &&
                      this.getNearestLocationName(
                        pincodeBinded.dataInternal.nearestOUDelivery
                      )
              )}
              {this.renderKeyValPair(
                'Address:',
                isFromPincode
                  ? pincodeBinded.dataInternal.nearestOUPickup &&
                      pincodeBinded.dataInternal.nearestOUPickup.locationAddress
                  : pincodeBinded.dataInternal.nearestOUDelivery &&
                      pincodeBinded.dataInternal.nearestOUDelivery
                        .locationAddress
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        {pincodeBinded.serviceable === false ? (
          <div>
            <div
              className={`${styles.serviceableContainer} responsive-jc-center responsive-ta-center l-row a-center`}
            >
              <BaseLineErrorIcon />
              <div className={`${styles.serviceableText} ${styles.failure}`}>
                {isNotServiceableMsg || 'Not Serviceable'}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  renderFromToInfo() {
    return (
      <div className={`${styles.divWrapper} responsive-d-b l-row j-space-bet`}>
        {this.renderPincodeInfo(true)}
        {this.renderPincodeInfo(false)}
      </div>
    );
  }

  renderMetaInfoHeading(key) {
    const Icon = key === 'docs' ? DocumentsListIcon : ClockIcon;
    const label =
      key === 'docs'
        ? 'Documents Required'
        : 'Estimated Turn Around Time (TAT)';
    return (
      <div className={`${styles.metaInfoHeadingDiv} l-row a-center`}>
        <Icon />
        <span className={styles.metaInfoHeading}>{label || ''}</span>
      </div>
    );
  }

  renderDocumentsMap() {
    const common = {};
    let docs;
    if (!this.state.fromToPairDetails) {
      const dataInternal =
        this.state.fromPincode.dataInternal ||
        this.state.toPincode.dataInternal;
      docs = dataInternal && dataInternal.industryTypToDocumentListMap;
      const docKeys = Object.keys(docs);
      for (let i = 0; i < docKeys.length; i += 1) {
        const documents = docs[docKeys[i]];
        documents.forEach(doc => {
          const list = common[doc] || [];
          if (list.indexOf(this.serviceTypes[docKeys[i]]) === -1) {
            list.push(this.serviceTypes[docKeys[i]]);
          }
          common[doc] = list;
        });
      }
    } else {
      const fromDocs =
        this.state.fromToPairDetails.fromPincodeDTO &&
        this.state.fromToPairDetails.fromPincodeDTO
          .industryTypToDocumentListMap;
      const fromKeys = Object.keys(fromDocs);
      for (let i = 0; i < fromKeys.length; i += 1) {
        const documents = fromDocs[fromKeys[i]];
        documents.forEach(doc => {
          const list = common[doc] || [];
          if (list.indexOf(this.serviceTypes[fromKeys[i]]) === -1) {
            list.push(this.serviceTypes[fromKeys[i]]);
          }
          common[doc] = list;
        });
      }

      const toDocs =
        this.state.fromToPairDetails.toPincodeDTO &&
        this.state.fromToPairDetails.toPincodeDTO.industryTypToDocumentListMap;
      const toKeys = Object.keys(toDocs);
      for (let i = 0; i < toKeys.length; i += 1) {
        const documents = toDocs[toKeys[i]];
        documents.forEach(doc => {
          const list = common[doc] || [];
          if (list.indexOf(this.serviceTypes[fromKeys[i]]) === -1) {
            list.push(this.serviceTypes[fromKeys[i]]);
          }
          common[doc] = list;
        });
      }
    }
    const iterableCommonKeys = Object.keys(common);
    return iterableCommonKeys.map(kk => (
      <div className={styles.metaInfoKey} key={kk}>
        {`${kk} (${(common[kk] || []).join(', ')})`}
      </div>
    ));
  }

  renderConditionsAppliedDocs() {
    if (this.state.fromToPairDetails) {
      return null;
    }
    if (this.state.fromPincode.dataInternal) {
      return (
        <div className={styles.metaInfoKeyLight}>
          {this.onlyFromDocsMessage}
        </div>
      );
    }
    if (this.state.toPincode.dataInternal) {
      return (
        <div className={styles.metaInfoKeyLight}>{this.onlyToDocsMessage}</div>
      );
    }
    return null;
  }

  renderDocuments() {
    return (
      <div
        className={`${styles.metaInfoBox} mobile-responsive-mw-80 responsive-mb-30 responsive-mw-60 responsive-m-a flex-40`}
      >
        {this.renderMetaInfoHeading('docs')}
        <div className={styles.metaInfoData}>
          {this.renderDocumentsMap()}
          {this.renderConditionsAppliedDocs()}
        </div>
      </div>
    );
  }

  renderTatDetails() {
    if (!this.state.fromToPairDetails) {
      return null;
    }
    let tatDays =
      this.state.fromToPairDetails &&
      this.state.fromToPairDetails.transitTATInDays;
    const fromOdaDaysExtra =
      (this.state.fromPincode &&
        this.state.fromPincode.odaDetail &&
        Number(this.state.fromPincode.odaDetail.additionalTat)) ||
      0;
    const toOdaDaysExtra =
      (this.state.toPincode &&
        this.state.toPincode.odaDetail &&
        Number(this.state.toPincode.odaDetail.additionalTat)) ||
      0;
    const tatDaysExtra = fromOdaDaysExtra + toOdaDaysExtra;
    tatDays += tatDaysExtra;
    const cutoffTime =
      this.state.fromToPairDetails &&
      moment.duration(this.state.fromToPairDetails.transitTatPickupCutoff);
    const cutoffTimeString = `${cutoffTime.hours()}:${
      cutoffTime.minutes() < 10 ? '0' : ''
    } ${cutoffTime.minutes()} Hrs`;
    return (
      <div
        className={`${styles.metaInfoBox} responsive-jc-center mobile-responsive-mw-80 responsive-mw-60 responsive-m-a flex-40`}
      >
        {this.renderMetaInfoHeading('tat')}
        <div className={styles.metaInfoData}>
          <div className={`${styles.metaInfoKey} l-row`}>
            {`${tatDays} working days*`}
            {this.getTatDaysExtraMessage(tatDaysExtra)}
          </div>
          <div className={styles.metaInfoKey}>
            {`Cutoff Pickup Time: ${cutoffTimeString}`}
          </div>
          <div className={styles.metaInfoKeyLight}>*Excluding Pickup Day</div>
        </div>
      </div>
    );
  }

  renderFromToMetaInfo() {
    if (
      !this.state.fromToPairDetails &&
      !this.state.fromPincode.dataInternal &&
      !this.state.toPincode.dataInternal
    ) {
      return null;
    }
    return (
      <div
        className={`${styles.divWrapper} ${styles.metaInfo} responsive-d-b responsive-jc-center l-row j-space-bet`}
      >
        {this.renderDocuments()}
        {this.renderTatDetails()}
      </div>
    );
  }

  renderDownload() {
    if (
      checkForExternalClient(this.props.userProfile) ||
      this.state.isCalledFromRivigo
    ) {
      return null;
    }
    return (
      <div
        className={`action-button-wrapper ${styles.download}`}
        onClick={() => this.handleDownloadOnClick()}
      >
        <div className="action-button">Download list of locations we serve</div>
      </div>
    );
  }

  renderCsvDownloader() {
    if (this.state.triggerDownload && this.props.pincodeState.downloadData) {
      jsonToCSVConvertor(
        (this.props.pincodeState && this.props.pincodeState.downloadData) || [],
        'pincodes',
        PincodeTableConfig.columns
      );
    }
    return null;
  }

  renderFloatbutton() {
    if (this.state.isCalledFromRivigo) {
      return null;
    }

    return (
      <div className={styles.floatButton}>
        <a
          href="https://api.whatsapp.com/send?phone=917042161516&text=CHECK"
          target="_blank"
        >
          <img src={WhatsappIcon} />
          <span>Check Serviceability on WhatsApp</span>
        </a>
      </div>
    );
  }

  renderClientsListForInternalUsers() {
    const { pincodeState } = this.props;

    const nullCheckOnClientList = () => {
      return (
        pincodeState &&
        pincodeState.clientList &&
        pincodeState.clientList.length
      );
    };
    const optionsArr = nullCheckOnClientList() ? pincodeState.clientList : [];

    if (nullCheckOnClientList() && pincodeState.clientList.length === 1) {
      this.handleSelect('', pincodeState.clientList[0]);
    }
    return (
      <div style={{ maxWidth: '200px' }}>
        <div className={`${styles.flexChild}`}>
          <label>Client Code</label>
          <Select
            label="Select client"
            selectedOpt={this.state.selectedClient}
            optionsArrOfObj={optionsArr}
            nameValStrings={this.selectedClientNameValString}
            onSelect={(val, obj) => this.handleSelect(val, obj)}
            disabled={false}
            enableSearch={true}
            disableNone={true}
            selectedWrapperClass={styles.selectWrapperClass}
          />
        </div>
      </div>
    );
  }

  render() {
    const isRivigoInternalUser = rivigoUser(this.props.userProfile);
    const validateFn = this.props.initServiceState.pincodeproto.validatePincode;
    const showInfoTag =
      !this.state.selectedClient &&
      (validateFn(this.state.fromPincode) ||
        validateFn(this.state.toPincode)) &&
      techSupportUser(this.props.userProfile);

    return (
      <div
        style={{
          fontFamily: this.state.fontFamily,
          fontWeight: this.state.fontWeight
        }}
        className={`${styles.checkPincodeWrapper} ${
          this.state.isCalledFromRivigo ? styles.rivigoWebsite : ''
        } responsive-p-0`}
      >
        {isRivigoInternalUser &&
          !this.state.isCalledFromRivigo &&
          this.renderClientsListForInternalUsers()}
        {this.renderFromToInfo()}
        {this.renderFromToMetaInfo()}
        {showInfoTag && (
          <div className={styles.message}>
            <img src={information} />
            Displaying internal TATs & charge buckets
          </div>
        )}
        {this.renderDownload()}
        {this.renderCsvDownloader()}
        {this.renderFloatbutton()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userProfile: state.userProfile,
  pincodeState: state.pincodeState,
  switchClientDropdownState: state.switchClientDropdownState,
  initServiceState: state.initServiceState
});

const mapDispatchToProps = {
  setPageName,
  checkPincodeServiceabilityNew,
  getFromToPairDetails,
  getAllServiceablePincodesViaClientCode,
  getClients
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckPincode);
